module.exports = __webpack_public_path__ + "img/iPhone.5d31f790.png";